/**
 *  このファイルはtools/generate.tsにより生成されたファイルです。手動で編集しないでください。
 */

import { z } from "zod";
const base = z.object({
  id: z.number(),
  createdAt: z.number(),
  updatedAt: z.number(),
  issuance_id: z.string().uuid().nullable(),
  lot_id: z.string().uuid().nullable(),
  carry_in_id: z.string().uuid().nullable(),
});
const create = base.extend({
});
const update = base.partial();
const put = create.omit({
  id: true,
  createdAt: true,
  updatedAt: true,
  issuance_id: true,
});
const patch = base.omit({
  createdAt: true,
  updatedAt: true,
  issuance_id: true,
})
.extend({ id: z.number() })
const rows = z.array(base);
const rowsWithPaging = z.object({
  count: z.number(),
  rows: rows,
});
const cache = base.omit({
  issuance_id: true,
}).extend({ cachedAt: z.number() });
const caches = z.array(cache);
export const MaterialBaseSchema = { base, put, patch, rows, rowsWithPaging, create, update, cache, caches };
export type MaterialBase = z.infer<typeof base>;
export type MaterialBasePutPayload = z.infer<typeof put>;
export type MaterialBasePatchPayload = z.infer<typeof patch>;
export type MaterialBaseRowsWithPaging = z.infer<typeof rowsWithPaging>;
export type MaterialBaseCreateAttributes = z.infer<typeof create>;
export type MaterialBaseUpdateAttributes = z.infer<typeof update>;
export type MaterialBaseCacheAttributes = z.infer<typeof cache>;
export type MaterialBaseCachesAttributes = z.infer<typeof caches>;